import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';
import { Cep } from '../viewModel/cep.model';
import {ICepVia} from '../interfaces/cep_via.interface';

@Injectable({ providedIn: 'root' })
export class CepService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient, 'cep');
    }

    public async buscaCep(cep: string): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<Cep>(`${this.path()}/buscarCep?cep=${cep}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }

    public async buscaCepVia(cep: string): Promise<ResultApi> {
        try {
            return this.httpClient
                .get<ICepVia>(`https://viacep.com.br/ws/${cep}/json`)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }
}
